export const GUARD_IS_ADMIN = 'GUARD_IS_ADMIN';
export const GUARD_IS_NOT_ADMIN = 'GUARD_IS_NOT_ADMIN';

export const GUARD_IS_LOGGED_IN = 'GUARD_IS_LOGGED_IN';
export const GUARD_IS_NOT_LOGGED_IN = 'GUARD_IS_NOT_LOGGED_IN';

export const GUARD_IS_NOT_VERIFIED = 'GUARD_IS_NOT_VERIFIED';
export const GUARD_IS_VERIFIED = 'GUARD_IS_VERIFIED';
